/* JDMuscle scroll motion (homepage only): left/right/up reveals + tile stagger. See jdm-scroll-motion.css. */
(() => {
  const d = document, root = d.documentElement, w = window;
  if (root.classList.contains('jdm-rv') || !d.body.classList.contains('index-template')) return;
  if (!('IntersectionObserver' in w) || w.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const S = '[id^="shopify-section-template--"]:not(.section-apps):not(.section-slideshow) ';
  const T = [
    ['.title-wrapper', 'l'], ['[id*="__cst_top_categories"] .page-width > .inline-block', 'l'],
    ['.gallery__item', 'u'], ['.multicolumn-list__item', 'u'], ['.product-grid > .grid__item', 'u'],
    ['.blog__post', 'u'], ['.cst-cat-child-container', 'u'],
    ['.richtext-banner', 'l'], ['.richtext-banner-copy', 'r'],
    ['.rich-left-container', 'l'], ['.rich-right-container', 'r'], ['.rich-bottom-center-copy', 'u'], ['.cst-btn-con', 'u'],
    ['.cst-two-column > .rte:nth-child(odd)', 'l'], ['.cst-two-column > .rte:nth-child(even)', 'r'],
    ['.jdm-community__header > div:first-child', 'l'], ['.jdm-community__header > .jdm-community__channel', 'r'],
    ['.jdm-community__playlist-player', 'l'], ['.jdm-community__playlist-copy', 'r'], ['.jdm-community__instagram', 'u']
  ];
  const vh = w.innerHeight, els = [];
  for (const [sel, dir] of T) {
    for (const el of d.querySelectorAll(sel.split(',').map(s => S + s.trim()).join(','))) {
      if (el.classList.contains('jdm-rv-el') || el.closest('.scroll-trigger') || el.querySelector('.scroll-trigger')) continue;
      const list = el.parentElement;
      if (list && list.scrollWidth > list.clientWidth + 2) continue; /* horizontal slider (mobile): leave as is */
      if (el.getBoundingClientRect().top < vh) continue;               /* above the fold: never hidden */
      el.classList.add('jdm-rv-el', 'jdm-rv-' + dir);
      els.push(el);
    }
  }
  if (!els.length) return;
  const show = el => { el.classList.add('jdm-in'); io.unobserve(el); };
  const io = new IntersectionObserver(entries => {
    entries.filter(e => e.isIntersecting).map(e => e.target)
      .sort((a, b) => { const r = a.getBoundingClientRect(), s = b.getBoundingClientRect(); return r.top - s.top || r.left - s.left; })
      .forEach((el, i) => { el.style.setProperty('--jdm-i', Math.min(i, 6)); show(el); });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
  els.forEach(el => io.observe(el));
  root.classList.add('jdm-rv');
  w.addEventListener('beforeprint', () => els.forEach(show));
})();
